module.exports = __webpack_public_path__ + "static/audiovideo-02432ca2624b738f05b2b1f2bbe71940.png";